// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".swiper-container[data-v-1c9f4288]{width:100%}.swiper-wrapper[data-v-1c9f4288]{align-items:center;width:100%}.swiper-slide[data-v-1c9f4288]{height:auto;text-align:center;width:-moz-fit-content;width:fit-content}.slide-image[data-v-1c9f4288]{width:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
